import React from 'react';
import * as RRCompat from 'react-router-dom-v5-compat';

const normalizeNode = (node: React.ReactNode): React.ReactNode => {
  if (!node) return node;

  if (React.isValidElement(node)) {
    if ((node.type as any)?.leagueRouteWrapper) {
      const { path, index, element, children } = (node.props as any) || {};
      return React.createElement(
        RRCompat.Route,
        { path, index, element },
        React.Children.map(children, (child: React.ReactNode) =>
          normalizeNode(child),
        ),
      );
    }

    if (node.type === React.Fragment) {
      const nextChildren = React.Children.map(
        (node.props as any).children,
        (child: React.ReactNode) => normalizeNode(child),
      );
      return React.cloneElement(node, undefined, nextChildren as any);
    }
  }

  return node;
};

const RoutesAdapter = ({ children }: { children?: React.ReactNode }) => {
  const normalizedChildren = React.useMemo(
    () => React.Children.map(children, child => normalizeNode(child)),
    [children],
  );

  return React.createElement(RRCompat.Routes, null, normalizedChildren);
};

export const createReactRouterV5CompatAdapter = () => ({
  useNavigate: RRCompat.useNavigate,
  useLocation: RRCompat.useLocation,
  useParams: RRCompat.useParams,
  useSearchParams: RRCompat.useSearchParams,
  useMatch: (pattern: any) => RRCompat.useMatch(pattern),
  Link: RRCompat.Link,
  Navigate: RRCompat.Navigate,
  Routes: RoutesAdapter,
  Route: RRCompat.Route,
  NavLink: RRCompat.NavLink,
  createRoutesFromChildren: RRCompat.createRoutesFromChildren,
  matchRoutes: RRCompat.matchRoutes,
  useNavigationType: RRCompat.useNavigationType,
  useInRouterContext: RRCompat.useInRouterContext,
  matchPath: RRCompat.matchPath,
});
